import {utilModule} from '../module.js';

utilModule.directive('nsOnblur', ['nsUtil', function(nsUtil) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elm, attr) {
            let old;

            if (attr.type === 'radio' || attr.type === 'checkbox') return;
            elm.bind('blur', function() {
                // requires to have $apply so that angular knows you have change the model
                scope.$apply(function() {
                    let data = elm[0].value;
                    if (nsUtil.isInteger(data)) {
                        data = parseInt(data, 10)
                    } else {
                        data = old;
                    }

                    let skuMaxQty = 0;
                    if (scope.config.skuMaxQty && scope.config.skuMaxQty[scope.item.sku] && (scope.config.skuMaxQty[scope.item.sku] > 0)) {
                        // skuMaxQty is trumping all other maxQty settings
                        skuMaxQty = scope.config.skuMaxQty[scope.item.sku];
                    } else {
                        if (scope.config.maxQty > 0) {
                            skuMaxQty = scope.config.maxQty;
                        }
                    }

                    //calculate cartMaxQty
                    let qty = 0;
                    for(let i=0; i<scope.order.item.length;i++) {
                        if(scope.order.item[i].sku != scope.item.sku) {
                            qty += scope.order.item[i].qty;
                        }
                    }
                    let cartMaxQty = scope.config.cartMaxQty-qty;

                    // lets update whatever the element has back to the model (this become an integer)
                    if ((skuMaxQty > 0) && (data > skuMaxQty)) {
                        scope.sections.cart.error.clearErrors();
                        if(skuMaxQty > cartMaxQty) {
                            data = cartMaxQty;
                            scope.isShowingCartMaxQtyExceeded = true;
                        } else {
                            data = skuMaxQty;
                            scope.isShowingMaxQtyExceeded = true;
                        }
                    } else if(data > cartMaxQty) {
                        data = cartMaxQty;
                        scope.sections.cart.error.clearErrors();
                        scope.isShowingCartMaxQtyExceeded = true;
                    }
                    scope.item['qty'] = data; // overwrite the model to become an integer!

                    if (data != old) {
                        // if it has any error
                        if (scope.$eval(attr.nsOnblur)) {
                            data = old;
                            scope.item['qty'] = old; // the model need to go back as well
                        }
                    }

                    // show it right after we do the simulate (onBlur function)
                    if (scope.isShowingMaxQtyExceeded) {
                        scope.sections.cart.error.infoMessages.push({text:scope.translation.maxQtyExceeded});
                        scope.isShowingMaxQtyExceeded = false;
                    } else if(scope.isShowingCartMaxQtyExceeded) {
                        scope.sections.cart.error.infoMessages.push({text:scope.translation.cartMaxQtyExceeded});
                        scope.isShowingCartMaxQtyExceeded = false;
                    }
                });
            });

            elm.bind('focus', function() {
                scope.$apply(function() {
                    let data = elm[0].value;
                    if (nsUtil.isInteger(data)) {
                        data = parseInt(data, 10)
                    } else {
                        data = 0;
                        elm[0].value = '0';
                    }

                    old = data;
                });
            });
        }
    };
}]);
